import React, { useState } from "react";
import { useHubx } from "../../HubX";
import { useHistory, useParams } from "react-router-dom";
import { DO_RESET_TOKEN_VALIDATE, DO_RESET_AUTHENTICATION } from "../../Fedx";
import { useSnackbar } from "notistack";
import IResetPassword from "../../core/contracts/IResetPassword";
import ResetPasswordPage from "../../screens/ResetPasswordPage";
import useConstructor from "../../core/hooks/useConstructor";
import { decodeStringFromBase64 } from "../../helpers/utility";

function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const hub = useHubx();
  const toastr = useSnackbar();
  const { token } = useParams();

  const doReset = async (authData: IResetPassword) => {
    try {
      setLoading(true);
      const tokenCoding = decodeStringFromBase64(token);

      if (tokenCoding.substr(0, 8) === "username") {
        authData.username = tokenCoding.substr(8);
        authData.token = "";
      } else if (tokenCoding.substr(0, 10) === "new_access") {
        authData.username = "";
        authData.token = tokenCoding.substr(11);
      }

      const results = await hub.request(DO_RESET_AUTHENTICATION, authData);

      if (results) {
        toastr.enqueueSnackbar("Senha atualizada com sucesso!", {
          variant: "success",
        });
      }

      redirect();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("doLogin -> error", error);
      toastr.enqueueSnackbar(error.data, {
        variant: "error",
      });
    }
    setLoading(false);
  };

  useConstructor(async () => {
    try {
      const tokenCoding = decodeStringFromBase64(token);

      if (tokenCoding.substr(0, 8) === "username") {
        hub.notify("is_alteration", true);
      } else if (tokenCoding.substr(0, 10) === "new_access") {
        await hub.request(DO_RESET_TOKEN_VALIDATE, tokenCoding.substr(11));
        hub.notify("is_new_access", true);
      } else {
        await hub.request(DO_RESET_TOKEN_VALIDATE, token);
      }
      // do stuff
    } catch (error) {
      toastr.enqueueSnackbar(error.data, {
        variant: "error",
      });

      redirect();
    }
  });

  const doCancel = async () => {
    redirect();
  };

  const redirect = () => {
    history.push("/");
  };

  return <ResetPasswordPage loading={loading} onSubmit={doReset} onCancel={doCancel} />;
}

export default ResetPassword;
